/**
 * Save for later — cart drawer + cart page line items.
 */
(function () {
  const STORAGE_KEY = 'onhow-wishlist';

  function readWishlist() {
    try {
      const items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(items) ? items : [];
    } catch {
      return [];
    }
  }

  function writeWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.querySelectorAll('.onhow-wishlist-count').forEach((el) => {
      el.textContent = items.length > 0 ? String(items.length) : '';
    });
    if (window.onhowWishlist && typeof window.onhowWishlist.updateWishlistCount === 'function') {
      window.onhowWishlist.updateWishlistCount();
    }
    document.dispatchEvent(new CustomEvent('skipp:wishlist-updated'));
  }

  function addToWishlist(productData) {
    const wishlist = readWishlist();
    const exists = wishlist.some(
      (item) =>
        (productData.id && item.id && String(item.id) === String(productData.id)) ||
        (item.title === productData.title && item.url === productData.url)
    );
    if (!exists) {
      wishlist.push(productData);
      writeWishlist(wishlist);
    }
  }

  function readProductData(button) {
    return {
      id: button.dataset.productId || '',
      handle: button.dataset.productHandle || '',
      title: button.dataset.productTitle || '',
      image: button.dataset.productImg || '',
      price: button.dataset.productPrice || '',
      url: button.dataset.productUrl || '',
    };
  }

  function removeLineFromCart(button, event) {
    const lineIndex = parseInt(button.dataset.lineIndex || '', 10);
    const variantId = button.dataset.variantId || undefined;
    if (!Number.isFinite(lineIndex) || lineIndex <= 0) return;

    const cartItems =
      button.closest('cart-drawer-items') || button.closest('cart-items');
    if (cartItems && typeof cartItems.updateQuantity === 'function') {
      cartItems.updateQuantity(lineIndex, 0, event, 'updates[]', variantId);
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.cart-item__save-later');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    addToWishlist(readProductData(button));
    document.dispatchEvent(new CustomEvent('skipp:show-wishlist-panel'));
    removeLineFromCart(button, event);
  });
})();
